import React from 'react'
import PropTypes from 'prop-types'

interface EditingActionButtonsProps {
  onCancel: () => void
  onDelete: () => void
  onPost: () => void
}

export function EditingActionButtons ({ onCancel, onDelete, onPost }: EditingActionButtonsProps): React.ReactElement {
  return (
    <div className='editing-action-buttons'>
      <button className='button pro-red-400 small' onClick={onDelete}>Delete</button>
      <button className='button pro-steel-grey-600 small' onClick={onCancel}>Cancel</button>
      <button className='button pro-blue-400 small' onClick={onPost}>Post</button>
    </div>
  )
}

EditingActionButtons.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPost: PropTypes.func.isRequired
}

interface ReplyingActionButtonsProps {
  onCancel: () => void
  onPost: () => void
}

export function ReplyingActionButtons ({ onCancel, onPost }: ReplyingActionButtonsProps): React.ReactElement {
  return (
    <div className='editing-action-buttons'>
      <button className='button pro-steel-grey-600 small' onClick={onCancel}>Cancel</button>
      <button className='button pro-blue-400 small' onClick={onPost}>Post</button>
    </div>
  )
}

ReplyingActionButtons.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onPost: PropTypes.func.isRequired
}
